import { Select } from "@/shared/components/atoms/Select";
import { Modal } from "@/shared/components/organisms/Modal";
import { ModalDescriptionExercise } from "@/shared/components/organisms/ModalDescriptionExercise";
import { faDumbbell, faPersonRays } from "@fortawesome/free-solid-svg-icons";
import { faCommand } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { t } from "i18next";

type Props = {
  openModalAcceptSearchTraining: any;
  handleOpenModalAcceptSearchTraining: any;
  trainingFormik: any;
  searchableOptions: any;
  openModalInfoExercise: any;
  handleOpenModalInfoExercise: any;
  saveLoader: boolean;
  openEquipmentExercise: any;
};

const Modals = ({
  openModalAcceptSearchTraining,
  handleOpenModalAcceptSearchTraining,
  trainingFormik,
  searchableOptions,
  openModalInfoExercise,
  handleOpenModalInfoExercise,
  openEquipmentExercise,
  saveLoader,

}: Props) => {
  return (
    <div>
      <Modal
        open={openModalAcceptSearchTraining}
        Close={() => {
          handleOpenModalAcceptSearchTraining?.();
        }}
        loader={saveLoader}
        onClickCreate={trainingFormik.handleSubmit}
        textButtonCreate={t("training-wizard.views.continue")}
        textButtonClose={t("general.cancel")}
        tittleModal={t("user.views.save_plan")}
      >
        <div className="grid grids-cols-1 gap-4">
          <div className="col-span-full mt-5">
            <p className="text-sm text-gray-500 px-4">
              {t("share.views.msg_searchable_plan_description")}
            </p>
          </div>
          <div className="col-span-full px-4">
            <Select
              name="searchable"
              options={searchableOptions}
              value={trainingFormik.values.searchable}
              onChange={trainingFormik.handleChange}
            />
          </div>
        </div>
      </Modal>
      <ModalDescriptionExercise
        Close={handleOpenModalInfoExercise}
        open={openModalInfoExercise}
        tittleModal={"Nombre del ejercicio"}
      >
        <div className="h-full max-h-[80vh] overflow-y-auto">
          <div className="flex justify-center">
            <video
              className="mb-3"
              src="/1.mp4"
              width="75%"
              height="300"
              controls
            ></video>
          </div>
          <h1 className="text-base font-semibold leading-6 text-gray-900 border-b border-gray-200 pb-3 mt-10">
            {t("share.views.description")}
          </h1>
          <ul role="list" className="space-y-6 mt-5">
            <li className="relative flex gap-x-4">
              <div className="h-6 absolute left-0 top-0 flex w-6 justify-center">
                <div className="w-px bg-gray-200" />
              </div>
              <div className="relative flex h-6 w-6 flex-none items-center justify-center bg-white">
                <div className="h-1.5 w-1.5 rounded-full bg-gray-100 ring-1 ring-gray-300 mt-1" />
              </div>
              <p className="flex-auto py-0.5 text-xs leading-5 text-gray-500">
                <span className="text-base text-gray-700">
                  Descripcion super larga de un ejercicio
                </span>
              </p>
            </li>
            <li className="relative flex gap-x-4">
              <div className="h-6 absolute left-0 top-0 flex w-6 justify-center">
                <div className="w-px bg-gray-200" />
              </div>
              <div className="relative flex h-6 w-6 flex-none items-center justify-center bg-white">
                <div className="h-1.5 w-1.5 rounded-full bg-gray-100 ring-1 ring-gray-300 mt-1" />
              </div>
              <p className="flex-auto py-0.5 text-xs leading-5 text-gray-500">
                <span className="text-base text-gray-700">
                  Descripcion super larga de un ejercicio
                </span>
              </p>
            </li>
            <li className="relative flex gap-x-4">
              <div className="h-6 absolute left-0 top-0 flex w-6 justify-center">
                <div className="w-px bg-gray-200" />
              </div>
              <div className="relative flex h-6 w-6 flex-none items-center justify-center bg-white">
                <div className="h-1.5 w-1.5 rounded-full bg-gray-100 ring-1 ring-gray-300 mt-1" />
              </div>
              <p className="flex-auto py-0.5 text-xs leading-5 text-gray-500">
                <span className="text-base text-gray-700">
                  Descripcion super larga de un ejercicio para ver que tal queda
                  en movil
                </span>
              </p>
            </li>
          </ul>
          {/* Aquí seguiría el resto del contenido */}
          <div className="grid grid-cols-2 gap-4 mt-5 px-5">
            {/* Sección de músculos */}
            <div className="">
              <h1 className="text-base font-semibold leading-6 text-gray-900 border-b border-gray-200 pb-3">
                {t("user.views.target_muscle")}
              </h1>
              {/* Lista de músculos */}
              <ul role="list" className="space-y-6 mt-5">
                <li className="relative flex gap-x-4">
                  <div className="h-6 absolute left-0 top-0 flex w-6 justify-center">
                    <div className="w-px bg-gray-200" />
                  </div>
                  <div className="relative flex h-6 w-6 flex-none items-center justify-center bg-white">
                    <div className="h-1.5 w-1.5 rounded-full bg-gray-100 ring-1 ring-gray-300 mt-1" />
                  </div>
                  <p className="flex-auto py-0.5 text-xs leading-5 text-gray-500">
                    <span className="text-base text-gray-700">Gluteos</span>
                  </p>
                </li>
              </ul>
            </div>
            <div className="">
              <h1 className="text-base font-semibold leading-6 text-gray-900 border-b border-gray-200 pb-3">
                {t("user.views.secound_muscle")}
              </h1>
              {/* Lista de músculos */}
              <ul role="list" className="space-y-6 mt-5">
                <li className="relative flex gap-x-4">
                  <div className="h-6 absolute left-0 top-0 flex w-6 justify-center">
                    <div className="w-px bg-gray-200" />
                  </div>
                  <div className="relative flex h-6 w-6 flex-none items-center justify-center bg-white">
                    <div className="h-1.5 w-1.5 rounded-full bg-gray-100 ring-1 ring-gray-300 mt-1" />
                  </div>
                  <p className="flex-auto py-0.5 text-xs leading-5 text-gray-500">
                    <span className="text-base text-gray-700">Triceps</span>
                  </p>
                </li>
              </ul>
            </div>
          </div>
          <h1 className="text-base font-semibold leading-6 text-gray-900 border-b border-gray-200 pb-3 mt-10">
            {t("user.views.equipments")}
          </h1>
          <div className="flex flex-col items-center mt-6">
            {openEquipmentExercise === "straight_bar" && (
              <>
                <img
                  src="/ImagesEquipmentsExercesices/weight-lifting.png"
                  alt="weight-lifting.png"
                  className="w-28 h-28 object-cover"
                />
                <p className="text-center text-xl text-gray-900 mt-5 font-semibold">
                  {t("data.equipments.straight_bar")}
                </p>
              </>
            )}
            {openEquipmentExercise === "ez_bar" && (
              <>
                <img
                  src="/ImagesEquipmentsExercesices/ez-bar.png"
                  alt="ez-bar.png"
                  className="w-28 h-28 object-cover"
                />
                <p className="text-center text-xl text-gray-900 mt-5 font-semibold">
                  {t("data.equipments.ez_bar")}
                </p>
              </>
            )}
            {openEquipmentExercise === "dumbbells" && (
              <>
                <FontAwesomeIcon
                  icon={faDumbbell}
                  className="w-28 h-28 object-cover"
                />
                <p className="text-center text-xl text-gray-900 mt-5 font-semibold">
                  {t("data.equipments.dumbbells")}
                </p>
              </>
            )}
            {openEquipmentExercise === "bank" && (
              <>
                <img
                  src="/ImagesEquipmentsExercesices/bench.png"
                  alt="bench.png"
                  className="w-28 h-28 object-cover"
                />
                <p className="text-center text-xl text-gray-900 mt-5 font-semibold">
                  {t("data.equipments.bank")}
                </p>
              </>
            )}
            {openEquipmentExercise === "pulley" && (
              <>
                <img
                  src="/ImagesEquipmentsExercesices/pulley.png"
                  alt="pulley.png"
                  className="w-28 h-28 object-cover"
                />
                <p className="text-center text-xl text-gray-900 mt-5 font-semibold">
                  {t("data.equipments.pulley")}
                </p>
              </>
            )}
            {openEquipmentExercise === "tape" && (
              <>
                <img
                  src="/ImagesEquipmentsExercesices/tape.png"
                  alt="tape.png"
                  className="w-28 h-28 object-cover"
                />
                <p className="text-center text-xl text-gray-900 mt-5 font-semibold">
                  {t("data.equipments.tape")}
                </p>
              </>
            )}
            {openEquipmentExercise === "elastic_band" && (
              <>
                <img
                  src="/ImagesEquipmentsExercesices/elastic-band.png"
                  alt="elastic-band.png"
                  className="w-28 h-28 object-cover"
                />
                <p className="text-center text-xl text-gray-900 mt-5 font-semibold">
                  {t("data.equipments.elastic_band")}
                </p>
              </>
            )}
            {openEquipmentExercise === "lift_own_weight" && (
              <>
                <FontAwesomeIcon
                  icon={faPersonRays}
                  className="w-28 h-28 object-cover"
                />
                <p className="text-center text-xl text-gray-900 mt-5 font-semibold">
                  {t("data.equipments.lift_own_weight")}
                </p>
              </>
            )}
            {openEquipmentExercise === "others" && (
              <>
                <FontAwesomeIcon
                  icon={faCommand}
                  className="w-28 h-28 object-cover"
                />
                <p className="text-center text-xl text-gray-900 mt-5 font-semibold">
                  {t("data.equipments.others")}
                </p>
              </>
            )}
          </div>
        </div>
      </ModalDescriptionExercise>
    </div>
  );
};

export default Modals;
